import React, { useState, useEffect } from 'react';
import styles from './viewSingleCandidate.module.scss';
import { Col, Row, Accordion, Card, Modal, Button, Image, Alert, Container, Badge, Tab, Tabs } from 'react-bootstrap';
import CSSLoader from '../../../../../shared/cssLoader';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { candidateRejectOffer, failFilteredCandidates, getCandidateDetails, getPresignedUrlToViewCandidateCV, markAsCandidateHired, markAsOfferSentAPI } from '../../../../../../services/util/hiringpipeline/candidates';
import { Document, Page } from 'react-pdf';
import { failCandidateManually} from '../../../../../../services/util/hiringpipeline/candidates';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CustomNavbar from '../../../../customNavbar';
import { CustomButton } from '../../../../../shared/customButton';
import { CustomAlertBoxCandidateProfile } from '../../../../../shared/customAlertBoxCandidateProfile';
import { CustomConfirmationModal } from '../../../../../shared/customConfirmationModal';
import { CustomConfirmationBox } from '../../../../../shared/customConfirmationBox';
import moment from 'moment';
import { checkCompanyEmailAccountConnection } from '../../../../../../services/util/company';
import { deleteCandidateProfile } from '../../../../../../services/util/hiringpipeline/candidates';
import SendEmailModal from './sendEmailModal';
import AddCandiateNoteModal from '../../../../common/addCandidateSpecialNoteModal'
import SubmitOfferModal from './../../../../offerHandling/submitOfferModal';
import ViewAssessmentModal from './viewAssessmentModal';
import ExtendAssessmentTimeModal from './ExtendAssessmentTimeModal';
import ExtendQuizTimeModal from './ExtendQuizTimeModal';
import CandidateCvView from '../../../../common/candidateCvView';
import CandidateSpecialNotesView from '../../../../common/candidateSpecialNotesView'
import CandidateCoverLetterView from '../../../../common/candidateCoverLetterView';
import CandidateAnswersToCustomQuestionsView from '../../../../common/candidateAnswersToCustomQuestionsView';
import CandidateEvaluationFlow from './candidateEvaluationFlow';
import Avatar from 'react-avatar';
import StarRating from '../../../../../shared/rate'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { style } from 'styled-system';
import ViewOffer from './viewOfferModalSingleCandidate'
import { CustomAlertBox } from '../../../../../shared/customAlertBox';
import { CustomConfirmationWithCheckPopUpBox } from '../../../../../shared/customConfirmationWithCheckPopUpBox';



const ViewSingleCandidate = (props) => {
    const [showViewOfferModal, setShowVieOfferwModal] = useState(false);
    let [isLoading, setLoading] = useState(true);
    let [accordionIcon, setAccordionIcon] = useState({
        rowid: '',
        icon: false
    });
    let [accordionIconForCustomQuestions, setAccordionIconForCustomQuestions] = useState({
        icon: false
    })
    const [showCVModal, setShowCVModal] = useState(false);
    let [numPages, setNumPages] = useState(null);
    const [defaultScalePrecentage, setScalePrecentage] = useState(100);
    const [defaultScale, setDefaultScale] = useState(1.6);
    let [pageNumber, setPageNumber] = useState(1);
    const [cvObject, setCVObject] = useState(null);
    let [isUserRoleAdmin, setUserRolAdmin] = useState(false);
    let [isUserRoleReviewer, setUserRolReviewer] = useState(false);
    let [deleteCandidateProfileDisable, setDeleteCandidateProfileDisable] = useState(false);
    let [candidateValues, setCandidateValues] = useState({
        candidate_email: '',
        candidate_name: '',
        candidate_phone: '',
        current_state: '',
        current_stage_id: '',
        current_stage_name: null,
        hiring_position: '',
        is_special_source: false,
        overall_score: '',
        review_criteria: [],
        photo_url: '',
        pipeline_name: '',
        special_source: '',
        special_source_additional_data: '',
        available_date: '',
        expected_salary: '',
        expected_salary_paid_by: '',
        custom_question_answers: '',
        cover_letter_url: '',
        cv_url: '',
        custom_question_answers: [],
        upcoming_pipeline_evaluation_steps_data: [],
        is_reject_email_sent: '',
        last_evaluation_pipeline_step: ''

    });

    let [hiringFlow, setHiringFlow] = useState({
        evaluation_stages: {
            state: 0,
            steps: []
        },
        filter_stage: null,
        hire_stage: null,
        offer_stage: null
    });

    //Actions Modal states
    let [actionStateModal, setActionStateModal] = useState({
        is_open: false,
        candidate_id_set: [],
        action_state: ''
    });

    //Actions Submit Loading
    let [actionsSubmitLoading, setActionsSubmitLoading] = useState(false);

    //let failed pipeline step id
    let [failedPipelineStepID, setFailedPipelineStepID] = useState('');

    let [sendEmailButtonDisabled, setSendEmailButtonDisabled] = useState(false);
    let [sendEmailModalOpen, setSendEmailModalOpen] = useState(false);
    let [emailConnectedModal, setEmailConnectedModal] = useState(false);
    let [isURLLoading, setURLLoading] = useState(false);

    //states for open modal for view assessment
    let [showViewAssessmentModal, setShowViewAssessmentModal] = useState(false);
    let [modalAssessmentData, setModalAssessmentData] = useState();

    //states for oprn and set data for quiz time extending modal
    let [showExtendQuizTimeModal, setshowExtendQuizTimeModal] = useState(false);
    let [quizTimeExtendingModalData, setQuizTimeExtendingModalData] = useState();

    //states for oprn and set data for assessment time extending modal
    let [showExtendAssessmentTimeModal, setShowExtendAssessmentTimeModal] = useState(false);
    let [assessmentTimeExtendingModalData, setAssessmentTimeExtendingModalData] = useState();


    let [isDownloadCVPending, setIsDownloadCVPending] = useState(false);
    let [isViewCVPending, setIsViewCVPending] = useState(false);

    let [activeTabKey, setActiveTabKey] = useState("evaluationDetails")
    let [specialNoteModalOpen, setSpecialNoteModalOpen] = useState(false);

    let [showDeleteCandidateModal, setShowDeleteCandidateModal] = useState(false);
    const options = {
        cMapUrl: 'cmaps/',
        cMapPacked: true,
    };
    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let [candidateID, setCandidateID] = useState(params.get('cid'));
    const history = useNavigate();
    let moment = require('moment-timezone');
    let [viewOfferValues, setViewOfferValues] = useState();

    const breadcrumb = [
        {
            pathaddress: '',
            pathname: 'Candidates',
            isActive: false,
            key: 'candidates'
        },
        {
            pathaddress: '',
            pathname: candidateValues.candidate_name,
            isActive: true,
            key: candidateValues.candidate_name
        }
    ]

    // Evaluation Stages
    const MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION = '10';
    const MANUALLY_REJECT_IN_EVALUATION = '20';
    const MANUALLY_PASS_FROM_FAILED_IN_EVALUATION = '30';
    // Filtered Stage
    const MARK_AS_OFFER_SENT_IN_FILTERD_STAGE = '110';
    const REJECT_IN_FILTERD_STAGE = '120';
    //Offer sent stage
    const MARK_AS_OFFER_DECLINED_IN_OFFER_STAGE = '210';
    const MARK_AS_OFFER_ACCEPTED_IN_OFFER_STAGE = '220';

    // functions

    function handleCVViewModalClose() {
        setShowCVModal(false);
    }

    //on pdf load success
    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages);
    }

    const getCandidateAllDetails = async () => {
        setLoading(true)
        let respond = await getCandidateDetails(candidateID);
        if (respond.success === true) {
            if(respond.data.user_role===0){
                     setUserRolAdmin(true);
            }else if(respond.data.user_role===20){
                setUserRolReviewer(true);
            }
            setCandidateValues(respond.data.candidate_details);
            setHiringFlow(respond.data.hiring_flow);
            setLoading(false)
        } else {
            setLoading(false)
            history(`/company/pipelines/${candidateValues.hiring_pipeline._id}`)
        }
    }

    const zoomin = () => {
        if (defaultScale < 2) {
            setDefaultScale(defaultScale + 0.2);
            setCvViewprecentage((defaultScale + 0.2));
        }

    }
    const zoomout = () => {
        if (defaultScale > 1.0000000000000002) {
            setDefaultScale(defaultScale - 0.2);
            setCvViewprecentage((defaultScale - 0.2));
        }
    }

    const setCvViewprecentage = (value) => {
        //check scale value and change precentage value according to scale value
        setScalePrecentage(value === 2 ? 150 : value === 1.8 ? 125 : value === 1.6 ? 100 : value === 1.4000000000000001 ? 75 : value === 1.2000000000000002 ? 50 : value === 1.0000000000000002 ? 25 : 0)
    }

    function nextPage() {
        if (pageNumber !== numPages) {
            setPageNumber(prevState => prevState + 1);
        }
    }

    function prevPage() {
        if (pageNumber !== 1) {
            setPageNumber(prevState => prevState - 1);
        }
    }
    const handleClose = () => {
        setShowVieOfferwModal(false);
    }

    //on action selected
    const onActionSelected = async (action_id, data_values) => {
        let candidate_id_array = [];
        candidate_id_array.push(data_values);

        if (action_id === MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION
            });
        }
        if (action_id === MANUALLY_REJECT_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_REJECT_IN_EVALUATION
            });
        }
        if (action_id === MANUALLY_PASS_FROM_FAILED_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_PASS_FROM_FAILED_IN_EVALUATION
            });
        }
        if (action_id === MARK_AS_OFFER_SENT_IN_FILTERD_STAGE) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MARK_AS_OFFER_SENT_IN_FILTERD_STAGE
            });
        }
        if (action_id === REJECT_IN_FILTERD_STAGE) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: REJECT_IN_FILTERD_STAGE
            });
        }
        if (action_id === MARK_AS_OFFER_DECLINED_IN_OFFER_STAGE) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MARK_AS_OFFER_DECLINED_IN_OFFER_STAGE
            });
        }
        if (action_id === MARK_AS_OFFER_ACCEPTED_IN_OFFER_STAGE) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MARK_AS_OFFER_ACCEPTED_IN_OFFER_STAGE
            });
        }
    };
    //view Offer modal
    const viewOffer = async (candidate_values, hiring_flow) => {
        let offer_data = {
            candidateId: candidate_values ? candidate_values.candidate_id : null,
            offerSessionId: hiring_flow.offer_stage.session_id ? hiring_flow.offer_stage.session_id : null,
            jobTitle: hiring_flow.offer_stage.offer_details.job_title ? hiring_flow.offer_stage.offer_details.job_title : null,
            allocation: hiring_flow.offer_stage.offer_details.allocation ? hiring_flow.offer_stage.offer_details.allocation : null,
            offerDescription: hiring_flow.offer_stage.offer_details.description ? hiring_flow.offer_stage.offer_details.description : null,
            packageReference: hiring_flow.offer_stage.offer_details.package_reference ? hiring_flow.offer_stage.offer_details.package_reference : null,
            offerReviewers: hiring_flow.offer_stage.offer_reviews ? hiring_flow.offer_stage.offer_reviews : null,
            pipelineName: candidate_values.pipeline_name ? candidate_values.pipeline_name : null,
            candidateName: candidate_values.candidate_name ? candidate_values.candidate_name : null,
            candidateEmail: candidate_values.candidate_email ? candidate_values.candidate_email : null,
            candidatePhoneNumber: candidate_values.candidate_phone ? candidate_values.candidate_phone : null,
            state: hiring_flow.offer_stage.state ? hiring_flow.offer_stage.state : null,
            stateValue: hiring_flow.offer_stage.state ? hiring_flow.offer_stage.state : null,
            candidateRejectReason: hiring_flow.offer_stage.candidate_response ? hiring_flow.offer_stage.candidate_response.candidateRejectReason : null,
            offer_sent_date: hiring_flow.offer_stage.offer_sending_details.offer_sent_date ? hiring_flow.offer_stage.offer_sending_details.offer_sent_date : null,
            offer_sent_mode: hiring_flow.offer_stage.offer_sending_details.offer_sent_mode ? hiring_flow.offer_stage.offer_sending_details.offer_sent_mode : null,
            candidate_respose_received_mode: hiring_flow.offer_stage.candidate_response ? hiring_flow.offer_stage.candidate_response.response_received_mode : null,
            candidate_respose_date: hiring_flow.offer_stage.candidate_response ? hiring_flow.offer_stage.candidate_response.candidate_response_date : null,
            offer_documents:  hiring_flow.offer_stage.offer_documents? hiring_flow.offer_stage.offer_documents : null,
        }
        await setViewOfferValues(offer_data)
        setShowVieOfferwModal(true);
    }

    //failcandidates from current pipeline step
    const manuallyFailFromCurrentStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await failCandidateManually(actionStateModal.candidate_id_set, candidateValues.current_stage_id, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
            props.GetTaskValues();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //mark as offer sent
    const markAsOfferSent = async () => {
        setActionsSubmitLoading(true);
        let respond = await markAsOfferSentAPI(actionStateModal.candidate_id_set);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //manually fail from filter step
    const manuallyFailFromFilterStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await failFilteredCandidates(actionStateModal.candidate_id_set, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
            props.GetTaskValues();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //reject sent offer
    const rejectOffer = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await candidateRejectOffer(actionStateModal.candidate_id_set, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //mark as hired candidate
    const markCandidateAsHired = async () => {
        setActionsSubmitLoading(true);
        let respond = await markAsCandidateHired(actionStateModal.candidate_id_set);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
        } else {
            setActionsSubmitLoading(false);
        }
    }

    function redirectToCompanySettings() {
        window.location.replace('/app/company/settings/integrations')
    }



    const sendEmailButtonClick = async () => {
        setSendEmailButtonDisabled(true);
        let respond = await checkCompanyEmailAccountConnection();
        if (respond.success === true) {
            if (respond.data.is_company_ready_for_email_automation) {
                setSendEmailModalOpen(true)
            } else {
                setEmailConnectedModal(true);
            }
            setSendEmailButtonDisabled(false);
        } else {
            setSendEmailButtonDisabled(false);
        }
    }

    const deleteCandidateDetails = async () => {
        setDeleteCandidateProfileDisable(true);
        setShowDeleteCandidateModal(true);  
    }

    //delete candidate profile
    const deleteCandidate = async () => {
        setActionsSubmitLoading(true);
        let respond = await deleteCandidateProfile(candidateID);
        if (respond.success === true) {
            setDeleteCandidateProfileDisable(false);
            setActionsSubmitLoading(false);
            setShowDeleteCandidateModal(false);
            getCandidateAllDetails();
        } else {
            setDeleteCandidateProfileDisable(false);
            setActionsSubmitLoading(false);
            setShowDeleteCandidateModal(false);
        }
    };

    //refresh data after submit offer
    const refreshDataAfterSubmitOffer = async () => {
        getCandidateAllDetails();
    };


    const setModalClose = () => {
        setShowViewAssessmentModal(false);
        setshowExtendQuizTimeModal(false);
        setShowExtendAssessmentTimeModal(false);
    }

    const downloadCVClick = async () => {
        setIsDownloadCVPending(true);
        let respond = await getPresignedUrlToViewCandidateCV(candidateID);
        if (respond.success === true) {
            if (respond.data.presigned_url) {
                setIsDownloadCVPending(false);
                window.open(respond.data.presigned_url)
            } else {
                setIsDownloadCVPending(false);
            }
        } else {
            setIsDownloadCVPending(false);
        }
    }

    const viewCVClick = async () => {
        setIsViewCVPending(true);
        let respond = await getPresignedUrlToViewCandidateCV(candidateID);
        if (respond.success === true) {

            if (respond.data.presigned_url) {
                setIsViewCVPending(false);
                setCVObject(respond.data.presigned_url);
                setShowCVModal(true);
            } else {
                setIsViewCVPending(false);
            }
        } else {
            setIsViewCVPending(false);
        }
    }

    const openSpecialNoteModal = () => {
        setSpecialNoteModalOpen(true);
    }

    const closeSpecialNoteModal = () => {
        setSpecialNoteModalOpen(false);
    }

    useEffect(() => {
        if (candidateID) {
            getCandidateAllDetails();
        }
    }, []);

    useEffect(() => {
        let pageHit = '/company/pipeline/view-candidate-profile';
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: pageHit});
    }, [])

    return (
        <div className={styles.bodyDiv}>
            <Helmet>
                <title>View Candidate | HireTrace</title>
            </Helmet>
            {/* view Offer */}
            {
                showViewOfferModal === true ?
                    (<ViewOffer handleClose={handleClose} showModal={showViewOfferModal} viewOfferValues={viewOfferValues ? viewOfferValues : null} />)
                    : null
            }


            {/* Manually fail pipeline step confirmation popup box start */}
            <CustomConfirmationBox
                show={actionStateModal.is_open && actionStateModal.action_state === MANUALLY_REJECT_IN_EVALUATION}
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onFormSubmit={manuallyFailFromCurrentStep}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are trying to manually reject selected candidate from the pipeline. Candidate overall status will be failed."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, reject candidate"
                checkboxLabel="I confirm to manually reject selected candidate from the pipeline."
            />
            {/* Manually fail pipeline step confirmation popup box end */}

            {/* Mark as offer sent from filtered step confirmation popup box start */}
            {/* <CustomConfirmationModal
                show={actionStateModal.is_open && actionStateModal.action_state === MARK_AS_OFFER_SENT_IN_FILTERD_STAGE}
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onPrimaryBtnClick={markAsOfferSent}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are manually passing selected candidate from filtered stage to the offer stage."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Yes, pass step!"
            /> */}
            {/*  Mark as offer sent from filtered step confirmation popup box end */}

            {/* Manually fail from filter step confirmation popup box start */}
            <CustomConfirmationBox
                show={actionStateModal.is_open && actionStateModal.action_state === REJECT_IN_FILTERD_STAGE}
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onFormSubmit={manuallyFailFromFilterStep}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are trying to manually reject selected candidate from the pipeline. Candidate overall status will be failed."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, reject candidate"
                checkboxLabel="I confirm to manually reject selected candidate from the pipeline."
            />
            <CustomConfirmationWithCheckPopUpBox
                show={showDeleteCandidateModal}
                confirmationType='danger'
                cancelIconclick={() => {
                    setShowDeleteCandidateModal(false);
                    setDeleteCandidateProfileDisable(false);
                }}
                onSecondaryBtnClick={() => {
                    setShowDeleteCandidateModal(false);
                    setDeleteCandidateProfileDisable(false);
                }}
                onFormSubmit={deleteCandidate}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message={"You are about to delete this Candidate !"}
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, delete!"
                checkboxLabel="Deleting the candidate's personal data First name, Last name, Mobile number, Email, Profile image, CV and Cover letter.
This action is permanent and cannot be undone."
            />

            {/* Manually fail from filter step confirmation popup box end */}

            {/* Mark as candidate reject offer confirmation popup box start */}
            <CustomConfirmationBox
                show={actionStateModal.is_open && actionStateModal.action_state === MARK_AS_OFFER_DECLINED_IN_OFFER_STAGE}
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onFormSubmit={rejectOffer}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are trying to mark selected candidate rejected sent offer. Candidate overall status will be failed."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, reject candidate"
                checkboxLabel="I confirm to mark as selected candidate is rejected sent offer"
            />
            {/* Mark as candidate reject offer confirmation popup box end */}

            {/* Pass to hired step confirmation popup box start */}
            <CustomConfirmationModal
                show={actionStateModal.is_open && actionStateModal.action_state === MARK_AS_OFFER_ACCEPTED_IN_OFFER_STAGE}
                confirmationType='success'
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onPrimaryBtnClick={markCandidateAsHired}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                confirmationMessage="You are marking selected candidate is hired."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Yes, pass step!"
            />
            <SubmitOfferModal
                showModal={actionStateModal.is_open && actionStateModal.action_state === MARK_AS_OFFER_SENT_IN_FILTERD_STAGE}
                handleClose={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                candidateID={candidateID}
                refreshData={refreshDataAfterSubmitOffer}
                GetTaskValues={props.GetTaskValues}
            />

            {/* Pass to hired step confirmation popup box end */}

            {/* SHOW CV Modal Start */}
            <Modal
                show={showCVModal}
                onHide={handleCVViewModalClose}
                backdrop="static"
                keyboard={false}
                centered
                size="xl"
                scrollable
            >
                <Modal.Body>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={handleCVViewModalClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>

                    <Container className={styles.actionBtnRow}>
                        <Card className={styles.cvViewCard}>
                            <Card.Header className={styles.cardHeaderCvView}>
                                <div className={styles.headerDetails}>
                                    <p className={styles.accordianHeaderTopic}><span className={styles.cvCardHeader}> CV of&nbsp;&nbsp;{candidateValues.candidate_name} </span></p>
                                    <div className={styles.pdfcomponentActions}>
                                        <div className={styles.cvZoomcomponent}>
                                            <Button className={styles.zoomBtn} onClick={() => zoomout()} disabled={defaultScalePrecentage === 25 ? true : false}>
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M15.75 15.7498L12.4875 12.4873" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M6 8.25H10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </Button>
                                            <p className="ms-2 me-2">{defaultScalePrecentage}%</p>
                                            <Button className={styles.zoomBtn} onClick={() => zoomin()} disabled={defaultScalePrecentage === 150 ? true : false}>
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M15.75 15.7498L12.4875 12.4873" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8.25 6V10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M6 8.25H10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </Button>
                                        </div>
                                        <div className={styles.pageChangerComponent}>
                                            <Button className={styles.pageMoveBtn} disabled={pageNumber === 1 ? true : false} onClick={() => prevPage()}>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15 6L9 12L15 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </Button>
                                            <span className="ms-2 me-2"><span>{pageNumber}/{numPages}</span></span>
                                            <Button className={styles.pageMoveBtn} disabled={pageNumber === numPages ? true : false} onClick={() => nextPage()}>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body className={styles.cvViewBody}>
                                <Document
                                    file={cvObject}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    options={options}
                                    loading={<div>
                                        <Col sm={{ span: 4, offset: 4 }}>
                                            <CSSLoader />
                                        </Col>
                                    </div>}
                                >

                                    <Page pageNumber={pageNumber} scale={defaultScale} />
                                </Document>
                            </Card.Body>
                        </Card>
                    </Container>
                </Modal.Body>
            </Modal>

            {/* Modal End */}

            {/* email connection Modal Start*/}

            <Modal
                show={emailConnectedModal}
                onHide={() => setEmailConnectedModal(false)}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body className={styles.modalBody}>

                    <div className={styles.popUpBoxTopicDiv}>
                        <p className={styles.popUpBoxTopic}>Connect Company Email</p>
                    </div>
                    <Container>
                        <Col>
                            <p className={styles.popUpBoxMessage}>Company email haven't configured.</p>
                        </Col>
                        <Col>
                            <p className={styles.popUpBoxMessageDesc}>Before sending email, connect one of your organization’s Google or Office 365 Email Accounts (ex :- careers@companyxxx.com). </p>
                        </Col>
                        {!isUserRoleAdmin && (
                            <Row>
                                <Col>
                                <CustomAlertBox
                                    alertBodyText="You don't have permission. Only admin users can connect the email account."
                                    alertType="warningAlert"
                                />
                                </Col>
                            </Row>
                        )}
                        <Container>
                            <Row>
                                <Col className="mb-2">
                                    <CustomButton
                                        name="respondAcceptBtn"
                                        buttonType="button"
                                        type="defaultBtn"
                                        label="Cancel"
                                        handleClick={() => setEmailConnectedModal(false)}
                                    />
                                </Col>
                                <Col>
                                    <CustomButton
                                        name="respondAcceptBtn"
                                        disabled={isUserRoleAdmin ? false: true}
                                        buttonType="button"
                                        type="primaryBtn"
                                        label="Connect Email"
                                        handleClick={redirectToCompanySettings}
                                    />
                                </Col>
                            </Row>
                        </Container>

                    </Container>
                </Modal.Body>
            </Modal>
            {specialNoteModalOpen &&
                <AddCandiateNoteModal showModal={specialNoteModalOpen} handleClose={() => setSpecialNoteModalOpen(false)} candidateID={candidateID} getCandidateAllDetails={getCandidateAllDetails} />
            }
            {/* email connection Modal end*/}

            {/* send email Modal start*/}
            {sendEmailModalOpen &&
                <SendEmailModal showModal={sendEmailModalOpen} handleClose={() => setSendEmailModalOpen(false)} candidateID={candidateID} getCandidateAllDetails={getCandidateAllDetails} />
            }
            {/* send email Modal end*/}
            {/* view assessment Modal start */}
            {
                showViewAssessmentModal === true &&
                <ViewAssessmentModal showDetailsModal={showViewAssessmentModal} assessmentData={modalAssessmentData} modalClose={setModalClose} />
            }
            {/* view assessment modal end */}
            {/* view Time Extending Modal start */}
            {
                showExtendQuizTimeModal &&
                <ExtendQuizTimeModal showDetailsModal={showExtendQuizTimeModal} modalClose={setModalClose} quizData={quizTimeExtendingModalData} getCandidateAllDetails={getCandidateAllDetails} />
            }
            {/* view Time Extending modal end */}
            {/* view Time Extending Modal start */}
            {
                showExtendAssessmentTimeModal &&
                <ExtendAssessmentTimeModal showDetailsModal={showExtendAssessmentTimeModal} modalClose={setModalClose} assessmentData={assessmentTimeExtendingModalData} getCandidateAllDetails={getCandidateAllDetails} />
            }
            {/* view Time Extending modal end */}

            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>

                    <Col sm={12} className={styles.mainContainer}>
                        {/* candidate review details */}
                        <Row>
                            <Col>
                                <div className={styles.reviewDetails}>
                                    <Row>
                                        <Col md={1} lg={2} xl={2} className={styles.candidatePhoto}>
                                            <Avatar src={candidateValues.photo_url} name={candidateValues.candidate_name} size="140" round={true} />
                                        </Col>
                                        <Col md={8} lg={8} xl={8} className={styles.candidateDetails}>
                                            <Row>
                                                <Col sm={4} lg={4}>
                                                    <Row className={styles.overviwFlex} >
                                                        <Col className={styles.overviewIconCol} sm={1} >
                                                            <div className={styles.overviewIcons}>
                                                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M3.74811 16.6352C4.19947 16.7719 4.80911 16.7719 5.84542 16.7719H13.6355C14.6718 16.7719 15.2814 16.7719 15.7328 16.6352M3.74811 16.6352C3.65133 16.6059 3.56183 16.5703 3.47696 16.527C3.05413 16.3116 2.71036 15.9678 2.49492 15.545C2.25 15.0643 2.25 14.435 2.25 13.1765V5.38644C2.25 4.12792 2.25 3.49866 2.49492 3.01797C2.71036 2.59515 3.05413 2.25138 3.47696 2.03594C3.95765 1.79102 4.58691 1.79102 5.84542 1.79102H13.6355C14.894 1.79102 15.5233 1.79102 16.004 2.03594C16.4268 2.25138 16.7706 2.59515 16.986 3.01797C17.2309 3.49866 17.2309 4.12792 17.2309 5.38644V13.1765C17.2309 14.435 17.2309 15.0643 16.986 15.545C16.7706 15.9678 16.4268 16.3116 16.004 16.527C15.9191 16.5703 15.8296 16.6059 15.7328 16.6352M3.74811 16.6352C3.74836 16.029 3.75199 15.7082 3.80566 15.4384C4.04208 14.2498 4.97119 13.3207 6.15975 13.0843C6.44918 13.0267 6.79722 13.0267 7.49332 13.0267H11.9876C12.6837 13.0267 13.0317 13.0267 13.3212 13.0843C14.5097 13.3207 15.4388 14.2498 15.6753 15.4384C15.7289 15.7082 15.7326 16.029 15.7328 16.6352M12.7366 7.40886C12.7366 9.06361 11.3952 10.405 9.74046 10.405C8.08571 10.405 6.74428 9.06361 6.74428 7.40886C6.74428 5.75411 8.08571 4.41268 9.74046 4.41268C11.3952 4.41268 12.7366 5.75411 12.7366 7.40886Z" stroke="#98A2B3" stroke-width="1.49809" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.OverViewDetails}>
                                                                <span className={styles.reviewDetailsEmail} id="adminPanel_hiringPipelines_viewPipeline_viewSingleCandidate_candidateNameId">{candidateValues.candidate_name}</span>
                                                                <span className={styles.reviewDetailsLabel}>Name</span>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={styles.overviwFlex} >
                                                        <Col className={styles.overviewIconCol} sm={1} >
                                                            <div className={styles.overviewIcons}>
                                                                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M2.25 5.24909L8.3659 9.53022C8.86115 9.87689 9.10877 10.0502 9.37812 10.1174C9.61604 10.1767 9.86488 10.1767 10.1028 10.1174C10.3721 10.0502 10.6198 9.87689 11.115 9.53022L17.2309 5.24909M5.84542 14.9867H13.6355C14.894 14.9867 15.5233 14.9867 16.004 14.7418C16.4268 14.5263 16.7706 14.1826 16.986 13.7597C17.2309 13.279 17.2309 12.6498 17.2309 11.3913V6.59737C17.2309 5.33886 17.2309 4.7096 16.986 4.22891C16.7706 3.80609 16.4268 3.46232 16.004 3.24688C15.5233 3.00195 14.894 3.00195 13.6355 3.00195H5.84542C4.58691 3.00195 3.95765 3.00195 3.47696 3.24688C3.05413 3.46232 2.71036 3.80609 2.49492 4.22891C2.25 4.7096 2.25 5.33886 2.25 6.59737V11.3913C2.25 12.6498 2.25 13.279 2.49492 13.7597C2.71036 14.1826 3.05413 14.5263 3.47696 14.7418C3.95765 14.9867 4.58691 14.9867 5.84542 14.9867Z" stroke="#98A2B3" stroke-width="1.49809" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.OverViewDetails}>
                                                                <span className={styles.reviewDetailsEmail} id="adminPanel_hiringPipelines_viewPipeline_viewSingleCandidate_candidateEmailId">{candidateValues.candidate_email}</span>
                                                                <span className={styles.reviewDetailsLabel}>Email</span>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={styles.overviwFlex} >
                                                        <Col className={styles.overviewIconCol} sm={1} >
                                                            <div className={styles.overviewIcons}>
                                                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M7.02805 7.3508C7.54939 8.43663 8.26007 9.45432 9.16011 10.3544C10.0601 11.2544 11.0778 11.9651 12.1637 12.4864C12.2571 12.5313 12.3038 12.5537 12.3629 12.5709C12.5729 12.6321 12.8307 12.5881 13.0086 12.4608C13.0586 12.425 13.1014 12.3822 13.187 12.2965C13.4489 12.0347 13.5799 11.9037 13.7115 11.8181C14.2081 11.4953 14.8482 11.4953 15.3447 11.8181C15.4764 11.9037 15.6073 12.0347 15.8692 12.2965L16.0151 12.4425C16.4132 12.8406 16.6123 13.0396 16.7204 13.2534C16.9354 13.6785 16.9354 14.1806 16.7204 14.6057C16.6123 14.8195 16.4132 15.0185 16.0151 15.4166L15.8971 15.5346C15.5004 15.9314 15.302 16.1297 15.0323 16.2812C14.7331 16.4493 14.2683 16.5702 13.9251 16.5691C13.6158 16.5682 13.4044 16.5082 12.9816 16.3882C10.7094 15.7433 8.56537 14.5265 6.77666 12.7378C4.98795 10.9491 3.77115 8.80506 3.12624 6.53291C3.00624 6.11011 2.94624 5.89871 2.94532 5.58939C2.9443 5.24617 3.06517 4.78139 3.23327 4.48214C3.38476 4.21246 3.58312 4.0141 3.97983 3.61739L4.0979 3.49932C4.49598 3.10124 4.69501 2.9022 4.90878 2.79408C5.33391 2.57906 5.83597 2.57906 6.2611 2.79408C6.47486 2.9022 6.6739 3.10124 7.07197 3.49932L7.21794 3.64528C7.47981 3.90715 7.61074 4.03809 7.69635 4.16976C8.01918 4.66629 8.01918 5.30641 7.69635 5.80295C7.61074 5.93461 7.47981 6.06555 7.21794 6.32742C7.13231 6.41304 7.0895 6.45586 7.05367 6.5059C6.92632 6.68375 6.88235 6.94161 6.94356 7.15161C6.96079 7.2107 6.98321 7.2574 7.02805 7.3508Z" stroke="#98A2B3" stroke-width="1.49809" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.OverViewDetails}>
                                                                <span className={styles.reviewDetailsValue}>{candidateValues.candidate_phone ? candidateValues.candidate_phone : 'Not available'}</span>
                                                                <span className={styles.reviewDetailsLabel}>Phone</span>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col sm={4} lg={4}>
                                                    <Row className={styles.overviwFlex} >
                                                        <Col className={styles.overviewIconCol} sm={1} >
                                                            <div className={styles.overviewIcons}>
                                                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M3.21094 6.28522L12.1995 6.28522M12.1995 6.28522C12.1995 7.52628 13.2056 8.53236 14.4466 8.53236C15.6877 8.53236 16.6938 7.52628 16.6938 6.28522C16.6938 5.04416 15.6877 4.03809 14.4466 4.03809C13.2056 4.03809 12.1995 5.04416 12.1995 6.28522ZM7.70521 12.2776L16.6938 12.2776M7.70521 12.2776C7.70521 13.5187 6.69913 14.5247 5.45808 14.5247C4.21702 14.5247 3.21094 13.5187 3.21094 12.2776C3.21094 11.0365 4.21702 10.0305 5.45808 10.0305C6.69913 10.0305 7.70521 11.0365 7.70521 12.2776Z" stroke="#98A2B3" stroke-width="1.49809" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.OverViewDetails}>
                                                                <span className={styles.reviewDetailsValue}>{candidateValues.pipeline_name}</span>
                                                                {candidateValues.current_state === -60 ? <span className={styles.reviewDetailsLabelError}>Pipeline Disabled</span>
                                                                    : <span className={styles.reviewDetailsLabel}>Pipeline</span>
                                                                }

                                                            </p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={styles.overviwFlex} >
                                                        <Col className={styles.overviewIconCol} sm={1} >
                                                            <div className={styles.overviewIcons}>
                                                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g clip-path="url(#clip0_7514_354947)">
                                                                        <path d="M6.95912 16.1195V5.6329C6.95912 4.93631 6.95912 4.58801 7.03569 4.30225C7.24347 3.52679 7.84919 2.92107 8.62465 2.71329C8.91042 2.63672 9.25871 2.63672 9.9553 2.63672C10.6519 2.63672 11.0002 2.63672 11.2859 2.71329C12.0614 2.92107 12.6671 3.52679 12.8749 4.30225C12.9515 4.58801 12.9515 4.93631 12.9515 5.6329V16.1195M4.86179 16.1195H15.0488C15.8878 16.1195 16.3073 16.1195 16.6278 15.9563C16.9097 15.8126 17.1389 15.5835 17.2825 15.3016C17.4458 14.9811 17.4458 14.5616 17.4458 13.7226V8.02985C17.4458 7.19084 17.4458 6.77133 17.2825 6.45087C17.1389 6.16899 16.9097 5.93981 16.6278 5.79618C16.3073 5.6329 15.8878 5.6329 15.0488 5.6329H4.86179C4.02278 5.6329 3.60328 5.6329 3.28282 5.79618C3.00093 5.93981 2.77175 6.16899 2.62813 6.45087C2.46484 6.77133 2.46484 7.19084 2.46484 8.02985V13.7226C2.46484 14.5616 2.46484 14.9811 2.62813 15.3016C2.77175 15.5835 3.00093 15.8126 3.28282 15.9563C3.60328 16.1195 4.02278 16.1195 4.86179 16.1195Z" stroke="#98A2B3" stroke-width="1.49809" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_7514_354947">
                                                                            <rect width="17.9771" height="17.9771" fill="white" transform="translate(0.964844 0.389648)" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.OverViewDetails}>
                                                                <span className={styles.reviewDetailsValue}>{candidateValues.hiring_position}</span>
                                                                <span className={styles.reviewDetailsLabel}>Position</span>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={styles.overviwFlex} >
                                                        <Col className={styles.overviewIconCol} sm={1} >
                                                            <div className={styles.overviewIcons}>
                                                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M7.70521 6.47863V16.2162M16.6938 13.22V16.2162M3.21094 2.7334V16.2162M12.1995 10.2239V16.2162" stroke="#98A2B3" stroke-width="1.49809" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>

                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.OverViewDetails}>
                                                                <span className={styles.reviewDetailsValue}>{candidateValues.current_stage_name ? candidateValues.current_stage_name : 'Not available'}</span>
                                                                <span className={styles.reviewDetailsLabel}>Current Stage</span>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col sm={4} lg={4}>
                                                    <Row className={styles.overviwFlex}>
                                                        <Col className={styles.overviewIconCol} sm={1} >
                                                            <div className={styles.overviewIcons}>
                                                                <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M10.4534 3.77353H8.58078C7.96025 3.77353 7.45721 4.27657 7.45721 4.8971C7.45721 5.51763 7.96025 6.02066 8.58078 6.02066H9.32982C9.95035 6.02066 10.4534 6.5237 10.4534 7.14423C10.4534 7.76476 9.95035 8.2678 9.32982 8.2678H7.45721M8.9553 3.02448V3.77353M8.9553 8.2678V9.01685M13.4496 6.02066H13.4571M4.46103 6.02066H4.46852M1.46484 3.17429L1.46484 8.86704C1.46484 9.70605 1.46484 10.1256 1.62813 10.446C1.77175 10.7279 2.00093 10.9571 2.28282 11.1007C2.60328 11.264 3.02278 11.264 3.86179 11.264L14.0488 11.264C14.8878 11.264 15.3073 11.264 15.6278 11.1007C15.9097 10.9571 16.1388 10.7279 16.2825 10.446C16.4458 10.1256 16.4458 9.70605 16.4458 8.86704V3.17429C16.4458 2.33528 16.4458 1.91578 16.2825 1.59532C16.1389 1.31343 15.9097 1.08425 15.6278 0.940627C15.3073 0.777345 14.8878 0.777345 14.0488 0.777345L3.86179 0.777344C3.02278 0.777344 2.60328 0.777344 2.28282 0.940626C2.00093 1.08425 1.77175 1.31343 1.62813 1.59532C1.46484 1.91578 1.46484 2.33528 1.46484 3.17429ZM13.8241 6.02066C13.8241 6.22751 13.6564 6.39519 13.4496 6.39519C13.2427 6.39519 13.0751 6.22751 13.0751 6.02066C13.0751 5.81382 13.2427 5.64614 13.4496 5.64614C13.6564 5.64614 13.8241 5.81382 13.8241 6.02066ZM4.83555 6.02066C4.83555 6.22751 4.66787 6.39519 4.46103 6.39519C4.25418 6.39519 4.0865 6.22751 4.0865 6.02066C4.0865 5.81382 4.25418 5.64614 4.46103 5.64614C4.66787 5.64614 4.83555 5.81382 4.83555 6.02066Z" stroke="#98A2B3" stroke-width="1.49809" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.OverViewDetails}>
                                                                <span className={styles.reviewDetailsValue}>{candidateValues.expected_salary ? candidateValues.expected_salary : 'Not available'}&nbsp;{candidateValues.expected_salary_paid_by && candidateValues.expected_salary_paid_by === 10 ? "(Hourly)" : candidateValues.expected_salary_paid_by === 20 ? "(Daily)" : candidateValues.expected_salary_paid_by === 30 ? "(Weekly)" : candidateValues.expected_salary_paid_by === 40 ? "(FortNight)" : candidateValues.expected_salary_paid_by === 50 ? "(Monthly)" : ''}</span>
                                                                <span className={styles.reviewDetailsLabel}>Salary Expectation</span>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={styles.overviwFlex} >
                                                        <Col className={styles.overviewIconCol} sm={1} >
                                                            <div className={styles.overviewIcons}>
                                                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M16.6938 7.86053H3.21094M16.6938 9.73315V6.96168C16.6938 5.70316 16.6938 5.0739 16.4488 4.59321C16.2334 4.17039 15.8896 3.82662 15.4668 3.61118C14.9861 3.36626 14.3569 3.36626 13.0983 3.36626H6.80636C5.54784 3.36626 4.91859 3.36626 4.4379 3.61118C4.01507 3.82662 3.6713 4.17039 3.45586 4.59321C3.21094 5.0739 3.21094 5.70316 3.21094 6.96168V13.2537C3.21094 14.5122 3.21094 15.1414 3.45586 15.6221C3.6713 16.0449 4.01507 16.3887 4.4379 16.6042C4.91859 16.8491 5.54784 16.8491 6.80636 16.8491H9.95235M12.9485 1.86816V4.86435M6.95617 1.86816V4.86435M11.825 14.6019L13.3231 16.1L16.6938 12.7293" stroke="#98A2B3" stroke-width="1.49809" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.OverViewDetails}>
                                                                <span className={styles.reviewDetailsValue}>{candidateValues.available_date ? moment(candidateValues.available_date).format("YYYY-MM-DD") : 'Not available'}</span>
                                                                <span className={styles.reviewDetailsLabel}>Available Date</span>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                    {candidateValues.is_special_source &&
                                                    <>
                                                    <Row className={styles.overviwFlex} >
                                                        <Col className={styles.overviewIconCol} sm={1} >
                                                                <div className={styles.overviewIcons}>
                                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M11.3346 4.95898L13.4596 7.08398M13.4596 7.08398L15.5846 4.95898M13.4596 7.08398V2.83398M11.3346 14.8757V14.0257C11.3346 12.8355 11.3346 12.2405 11.103 11.7859C10.8993 11.3861 10.5742 11.061 10.1744 10.8573C9.7198 10.6257 9.12475 10.6257 7.93464 10.6257H4.81797C3.62786 10.6257 3.0328 10.6257 2.57824 10.8573C2.17839 11.061 1.85331 11.3861 1.64958 11.7859C1.41797 12.2405 1.41797 12.8355 1.41797 14.0257V14.8757M8.85547 5.31315C8.85547 6.68236 7.74551 7.79232 6.3763 7.79232C5.0071 7.79232 3.89714 6.68236 3.89714 5.31315C3.89714 3.94394 5.0071 2.83398 6.3763 2.83398C7.74551 2.83398 8.85547 3.94394 8.85547 5.31315Z" stroke="#98A2B3" stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                </div>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.OverViewDetails}>
                                                                <span className={styles.reviewDetailsValue}>{candidateValues.special_source_additional_data.name}</span>
                                                                <span className={styles.reviewDetailsLabel}>{candidateValues.special_source} </span>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                    </>
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg={2} >
                                            <div>
                                                {(candidateValues.current_state === 40 || candidateValues.current_state === 60 || candidateValues.current_state === 65) &&
                                                    <Alert variant="success" className={styles.successAlert}>
                                                        <p className="mb-0">Hired</p>
                                                        {/* <p className={styles.hiredDateLabel}>{hiringFlow.hire_stage ? hiringFlow.hire_stage.hired_date : ''}</p> */}
                                                    </Alert>
                                                }
                                                {candidateValues.current_state === -10 && (
                                                    <Alert variant="danger" className={styles.rejectFailAlert}>
                                                        <span>
                                                            <span
                                                                className={styles.rejectEmailSendConfirmationIcon}
                                                                data-tooltip-id={`Reject_email_sent`}
                                                            >
                                                                {candidateValues.is_reject_email_sent && (
                                                                    <i className="fas fa-envelope"></i>
                                                                )}
                                                            </span>
                                                            Rejected
                                                        </span>
                                                    </Alert>
                                                )}
                                                {candidateValues.is_reject_email_sent && (
                                                    <ReactTooltip id={`Reject_email_sent`} place="top" effect="solid">
                                                        Reject Email Sent
                                                    </ReactTooltip>
                                                )}

                                                {candidateValues.current_state === -30 &&
                                                    <Alert variant="danger" className={styles.rejectFailAlert}>Rejected at Offer Stage</Alert>
                                                }
                                                {candidateValues.current_state === 0 &&
                                                    <Alert variant="warning" className={styles.pendingAlert}>Pending Evaluation</Alert>
                                                }
                                                {candidateValues.current_state === 10 &&
                                                    <Alert variant="warning" className={styles.pendingAlert}>Pending at Qualified for Offer</Alert>
                                                }
                                                {(candidateValues.current_state === 30) &&
                                                    <Alert variant="warning" className={styles.pendingAlert}>Offer Processing</Alert>
                                                }
                                                {candidateValues.current_state === -50 &&
                                                    <Alert variant="danger" className={styles.rejectFailAlert}>Rejected at Onboarding</Alert>
                                                }
                                                 {candidateValues.current_state === -100 &&
                                                    <Alert variant="danger" className={styles.rejectFailAlert}>Deleted</Alert>
                                                }
                                            </div>
                                            <div className={styles.actionBtnBoxNormal}>
                                                {candidateValues.current_state !== -100 &&
                                                    <div>
                                                        <CustomButton
                                                            buttonType="button"
                                                            label="Send Email"
                                                            type="defaultBtn"
                                                            handleClick={() => sendEmailButtonClick()}
                                                            disabled={sendEmailButtonDisabled ? true : false}
                                                            backicon={sendEmailButtonDisabled && <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>}
                                                            frontIcon={<i class="fas fa-envelope"></i>}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={7} lg={8} xl={9}>
                                {/* view cv , cover letter and Custom Questions  */}
                                <Tabs
                                    activeKey={activeTabKey}
                                    id="controlled-tab-example"
                                    onSelect={(e) => setActiveTabKey(e)}
                                    className={styles.subtopic}
                                >
                                    <Tab eventKey="evaluationDetails" title="Evaluation Details" tabClassName={styles.tabcontent}>
                                        <br></br>
                                        <CandidateEvaluationFlow hiringFlow={hiringFlow} candidateValues={candidateValues} candidateID={candidateID} permissions={props.permissions} getCandidateAllDetails={getCandidateAllDetails} GetTaskValues={props.GetTaskValues} />

                                    </Tab>
                                    <Tab eventKey="cv" title="CV" tabClassName={styles.tabcontent} >
                                        <CandidateCvView candidateValues={candidateValues} cvURL={candidateValues.cv_url} candidateID={candidateID}
                                        />
                                    </Tab>
                                    {candidateValues.cover_letter_url ?
                                        <Tab eventKey="CoverLetter" title="Cover Letter" tabClassName={styles.tabcontent}>
                                            <CandidateCoverLetterView candidateValues={candidateValues} coverLetterURL={candidateValues.cover_letter_url} candidateID={candidateID} />
                                        </Tab>
                                        : null}
                                    {candidateValues.custom_question_answers && candidateValues.custom_question_answers.length > 0 ?
                                        <Tab eventKey="customQuestions" title="Answers For Custom Questions" tabClassName={styles.tabcontent}>
                                            <CandidateAnswersToCustomQuestionsView candidateValues={candidateValues} />
                                        </Tab>
                                        : null}
                                    <Tab eventKey="specialNotes" title={"Special Notes " + "(" + `${candidateValues.special_notes.length ? candidateValues.special_notes.length : "0"}` + ")"} tabClassName={styles.tabcontent}>
                                        <CandidateSpecialNotesView candidateValues={candidateValues} candidateID={candidateID} openSpecialNoteModal={openSpecialNoteModal} closeSpecialNoteModal={closeSpecialNoteModal} />
                                    </Tab>
                                </Tabs>
                                {activeTabKey === "evaluationDetails" && <div>
                                    {/* Filter stage */}
                                    <Card className={hiringFlow.filter_stage ? styles.customCardFilterStage : styles.customCardFilterStageDisabled}>
                                        <Card.Header className={hiringFlow.filter_stage ? styles.customCardHeaderFilterStage : styles.customCardHeaderFilterStageDisabled}>
                                            <Col>
                                                <Row >
                                                    <Col className={styles.centered}>
                                                        <span className="mt-1 mb-1" >Qualified for Offers</span>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Card.Header>
                                        <Card.Body className={styles.stageCardBody}>
                                            {hiringFlow.filter_stage ? <p className={styles.stageFeedbackLabel}>Ready for Offers Action</p> : ''}
                                            {hiringFlow.filter_stage && <Row className="ml-0 mr-0">
                                                <Col>
                                                    <Row>
                                                        <Col md={3}>
                                                            {hiringFlow.filter_stage && hiringFlow.filter_stage.state === 0 ?
                                                                <p className={styles.userDetailsTopicLabelsBottom}>Moved by</p>
                                                                : hiringFlow.filter_stage && hiringFlow.filter_stage.state === -20 ?
                                                                    <p className={styles.userDetailsTopicLabelsBottom}>Reject by</p>
                                                                    : hiringFlow.filter_stage && hiringFlow.filter_stage.state === 10 ?
                                                                        <p className={styles.userDetailsTopicLabelsBottom}>Moved by</p>
                                                                        : null
                                                            }
                                                        </Col>
                                                        <Col className='ms-4'>
                                                            <p className={styles.filteerDetailsData}>{hiringFlow.filter_stage && hiringFlow.filter_stage.action_by_name ? <span> {hiringFlow.filter_stage.action_by_name} ({hiringFlow.filter_stage.action_by_email})</span> : 'N/A'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={3} >
                                                            {hiringFlow.filter_stage && hiringFlow.filter_stage.state === 10 ?
                                                                <p className={styles.userDetailsTopicLabelsBottom}>Moved at</p>
                                                                : hiringFlow.filter_stage && hiringFlow.filter_stage.state === -20 ?
                                                                    <p className={styles.userDetailsTopicLabelsBottom}>Reject at</p>
                                                                    : hiringFlow.filter_stage && hiringFlow.filter_stage.state === 0 ?
                                                                        <p className={styles.userDetailsTopicLabelsBottom}>Moved at</p>
                                                                        : null
                                                            }
                                                        </Col>
                                                        <Col className='ms-4'>
                                                            {hiringFlow.filter_stage && hiringFlow.filter_stage.state === 10 ?
                                                                <p className={styles.filterDetailsDataBottom}>{hiringFlow.filter_stage && hiringFlow.filter_stage.filtered_date ? <span>{moment(hiringFlow.filter_stage.filtered_date).format('MMMM Do YYYY, h:mm A')}(UTC)</span> : 'Not Available'}</p>
                                                                : hiringFlow.filter_stage && hiringFlow.filter_stage.state === -20 ?
                                                                    <p className={styles.filterDetailsDataBottom}>{hiringFlow.filter_stage && hiringFlow.filter_stage.reject_date ? <span>{moment(hiringFlow.filter_stage.reject_date).format('MMMM Do YYYY, h:mm A')}(UTC)</span> : 'Not Available'}</p>
                                                                    : hiringFlow.filter_stage && hiringFlow.filter_stage.state === 0 ?
                                                                        <p className={styles.filterDetailsDataBottom}>N/A</p>
                                                                        : null
                                                            }

                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col lg={4} className={styles.alingRight}>
                                                    {hiringFlow.filter_stage && hiringFlow.filter_stage.state === 0 &&
                                                        <Row>
                                                            <Col>
                                                                <div data-tooltip-id={`no_permission_to_pass`}>
                                                                    <Button className={styles.actionBtnCurrentStepPass} onClick={() => onActionSelected(MARK_AS_OFFER_SENT_IN_FILTERD_STAGE, candidateID)} disabled={props.permissions.is_enabled === false || props.role === 1 ? true : false}>Prepare Offer</Button>
                                                                    {props.permissions.is_enabled === false && (
                                                                        <ReactTooltip id={`no_permission_to_pass`} place="top" effect="solid">
                                                                            <span>You don't have enough permissions to perform this action</span>
                                                                        </ReactTooltip>
                                                                    )}
                                                                </div>

                                                            </Col>
                                                            <Col>
                                                                <div data-tooltip-id={`no_permission_to_fail`}>
                                                                    <Button className={styles.actionBtnCurrentStepFail} data-tooltip-id={`no_permission`} onClick={() => onActionSelected(REJECT_IN_FILTERD_STAGE, candidateID)} disabled={props.permissions.is_enabled === false || props.role === 1 ? true : false}>Reject Candidate</Button>
                                                                    {props.permissions.is_enabled === false && (
                                                                        <ReactTooltip id={`no_permission_to_fail`} place="top" effect="solid">
                                                                            <span>You don't have enough permissions to perform this action</span>
                                                                        </ReactTooltip>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    }
                                                    {hiringFlow.filter_stage && hiringFlow.filter_stage.state === -20 &&
                                                        <Alert variant="danger" className={styles.badgeTypeFail}>Rejected</Alert>
                                                    }
                                                    {hiringFlow.filter_stage && hiringFlow.filter_stage.state === 10 &&
                                                        <Alert variant="success" className={styles.badgeType}>Moved to Offer Stage</Alert>
                                                    }
                                                </Col>

                                                <Row>
                                                    <Col lg={4} className='mt-4'>
                                                        {hiringFlow.filter_stage && hiringFlow.filter_stage.state === -20 &&
                                                            <div>
                                                                <p className={styles.userDetailsTopicLabels}>Reject Reason</p>
                                                                <span className={styles.rejectReson}><i className="fas fa-circle"></i>&nbsp;{hiringFlow.filter_stage.reject_reason}</span>
                                                            </div>
                                                        }
                                                    </Col>
                                                </Row>

                                            </Row>}
                                            {!hiringFlow.filter_stage && <Row className="ml-0 mr-0">
                                                <Col >
                                                    <p className={styles.noDataMessage}>Details Not Available</p>
                                                </Col>
                                            </Row>}
                                        </Card.Body>
                                    </Card>

                                    {/*  Offer stage */}
                                    <Card className={hiringFlow.offer_stage ? styles.customCardOfferStage : styles.customCardOfferStageDisabled}>
                                        <Card.Header className={hiringFlow.offer_stage ? styles.customCardHeaderOfferStage : styles.customCardHeaderOfferStageDisabled}>
                                            <Col>
                                                <Row>
                                                    <Col className={styles.centered}>
                                                        <span className="mt-1 mb-1">Processing Offers Details</span>
                                                    </Col>

                                                </Row>
                                            </Col>
                                        </Card.Header>
                                        <Card.Body className={styles.stageCardBody}>
                                            {hiringFlow.offer_stage &&
                                                <div>
                                                    <Row>
                                                        <Col>
                                                            <Row className={styles.offerStageBodyRow}>
                                                                {!isUserRoleReviewer &&
                                                                    <Col>
                                                                        <div><span className={styles.viweOffer} onClick={() => viewOffer(candidateValues, hiringFlow)}>View Offer</span></div>
                                                                    </Col>
                                                                }
                                                                
                                                                <Col className={styles.filterstatusRow}>
                                                                    {hiringFlow.offer_stage.state == 0 &&
                                                                        <Alert variant="warning" className={styles.pendingAlertStage}>Offer Processing</Alert>
                                                                    }
                                                                    {hiringFlow.offer_stage.state == 10 &&
                                                                        <Alert variant="warning" className={styles.pendingAlertStage}>Offer Processing</Alert>
                                                                    }
                                                                    {hiringFlow.offer_stage.state == 20 &&
                                                                        <Alert variant="warning" className={styles.pendingAlertStage}>Offer Processing</Alert>
                                                                    }
                                                                    {hiringFlow.offer_stage.state == 30 &&
                                                                        <Alert variant="success" className={styles.badgeType}>Offer Accepted</Alert>
                                                                    }
                                                                    {hiringFlow.offer_stage.state == -10 &&
                                                                        <Alert variant="danger" className={styles.failAlert}>Offer Rejected</Alert>
                                                                    }
                                                                    {hiringFlow.offer_stage.state == -20 &&
                                                                        <Alert variant="danger" className={styles.failAlert}>Candidate Declined</Alert>
                                                                    }
                                                                    {hiringFlow.offer_stage.state == -30 &&
                                                                        <Alert variant="danger" className={styles.failAlert}>Offer Retracted</Alert>
                                                                    }

                                                                </Col>
                                                            </Row>

                                                        </Col>
                                                    </Row>

                                                    <Row >


                                                        <Col className='mt-4 '>
                                                            <p className={styles.stageFeedbackLabel}>Offer Preparation</p>

                                                            <Row className='mb-2 '>
                                                                <Col>
                                                                    <Row>
                                                                        <Col lg={2}>
                                                                            <p className={styles.userDetailsTopicLabels}>Prepared by</p>
                                                                        </Col>
                                                                        <Col className='ms-5'>
                                                                            <p className={styles.userDetailsData}>{hiringFlow.filter_stage && hiringFlow.filter_stage.action_by_name ? <span> {hiringFlow.filter_stage.action_by_name} ({hiringFlow.filter_stage.action_by_email})</span> : 'N/A'}</p>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={2}>
                                                                            <p className={styles.userDetailsTopicLabels}>Prepared at </p>
                                                                        </Col>
                                                                        <Col className='ms-5'>
                                                                            <p className={styles.userDetailsDataBottom}>{hiringFlow.filter_stage && hiringFlow.filter_stage.filtered_date ? <span>{moment(hiringFlow.filter_stage.filtered_date).format('MMMM Do YYYY, h:mm A')}(UTC)</span> : 'Not Available'}</p>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={2}>
                                                                            <p className={styles.userDetailsTopicLabels}>State</p>
                                                                        </Col>
                                                                        <Col className='ms-5'>
                                                                            <p className={styles.reviewerStateSuccess}>
                                                                                <span>Offer Prepared</span>
                                                                            </p>
                                                                        </Col>
                                                                    </Row>

                                                                </Col>

                                                            </Row>
                                                            <p className={styles.stageFeedbackLabelTopMargin}>Offer Approval Feedback</p>
                                                            {(hiringFlow.offer_stage.offer_reviews).map((reValues, index) => (
                                                                <Row className={((hiringFlow.offer_stage.offer_reviews).length === (index + 1)) ? styles.adjustRowMarginsContentWithoutBorder : styles.adjustRowMarginsContent}>
                                                                    <Col key={index} className='mb-3'>
                                                                        <Row>
                                                                            <Col md={2}>
                                                                                <p className={styles.userDetailsTopicLabels}>
                                                                                    {reValues.state === -10 ? <span>Rejected by</span> : <span>Approved by</span>}
                                                                                </p>
                                                                            </Col>
                                                                            <Col className='ms-5'>
                                                                                <p className={styles.userDetailsData}><span>{reValues.reviewer_name} ({reValues.reviewer_email})</span></p>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col md={2}>
                                                                                <p className={styles.userDetailsTopicLabels}>
                                                                                    {reValues.state === -10 ? <span>Rejected at</span> : <span>Approved at</span>}
                                                                                </p>
                                                                            </Col>
                                                                            <Col className='ms-5'>
                                                                                <p className={styles.userDetailsData}>{reValues.review_date ? <span>{moment(reValues.review_date).format('MMMM Do YYYY, h:mm A')} (UTC)</span> : <span>N/A</span>}</p>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col md={2}>
                                                                                <p className={styles.userDetailsTopicLabels}>State</p>
                                                                            </Col>
                                                                            <Col className='ms-5'>
                                                                                <p className={reValues.state === 0 ? styles.reviewerStateWarning : reValues.state === 10 ? styles.reviewerStateSuccess : reValues.state === -10 ? styles.reviewerStateWarning : null}>
                                                                                    {reValues.state === 0 ? <span>Pending</span> : reValues.state === 10 ? <span>Offer Approved</span> : reValues.state === -10 ? <span>Rejected</span> : null}
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                        {reValues.state === -10 ?
                                                                            <Row>
                                                                                <Col className='mt-2'>
                                                                                    <div>
                                                                                        <p className={styles.userDetailsTopicLabels}>Reject Reason</p>
                                                                                        <span className={styles.rejectReson}><i className="fas fa-circle"></i>&nbsp;{reValues.comments}</span>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row> : null}
                                                                    </Col>
                                                                </Row>
                                                            ))}

                                                            {hiringFlow.offer_stage.offer_sending_details.offer_sent_by ?
                                                                <>
                                                                    <p className={styles.stageFeedbackLabelTopMargin}>Offer Send Details</p>
                                                                    <Row className={styles.adjustRowMarginsContentWithoutBorder}>
                                                                        <Col className='mb-3'>
                                                                            <Row>
                                                                                <Col md={2}>
                                                                                    <p className={styles.userDetailsTopicLabels}>Sent by</p>
                                                                                </Col>
                                                                                <Col className='ms-5'>
                                                                                    <p className={styles.userDetailsData}>
                                                                                        {hiringFlow.offer_stage.offer_sending_details.offer_sent_by ?
                                                                                            <span>{hiringFlow.offer_stage.offer_sending_details.offer_sent_by.first_name} {hiringFlow.offer_stage.offer_sending_details.offer_sent_by.last_name} ({hiringFlow.offer_stage.offer_sending_details.offer_sent_by.email})</span>
                                                                                            : <span> N/A </span>}
                                                                                    </p>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col md={2}>
                                                                                    <p className={styles.userDetailsTopicLabels}>Sent at</p>
                                                                                </Col>
                                                                                <Col className='ms-5'>
                                                                                    <p className={styles.userDetailsData}>
                                                                                        {hiringFlow.offer_stage.offer_sending_details.offer_sent_date ? <span>{moment(hiringFlow.offer_stage.offer_sending_details.offer_sent_date).format('MMMM Do YYYY, h:mm A')}(UTC)</span> : <span>N/A</span>}
                                                                                    </p>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col md={2}>
                                                                                    <p className={styles.userDetailsTopicLabels}>State</p>
                                                                                </Col>
                                                                                <Col className='ms-5'>
                                                                                    {hiringFlow.offer_stage.offer_sending_details.offer_sent_date ?
                                                                                        <p className={styles.reviewerStateSuccess}>
                                                                                            <span>Offer Sent</span>
                                                                                        </p> : <p className={styles.reviewerStateWarning}>
                                                                                            <span>Pending</span>
                                                                                        </p>}

                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                </> : hiringFlow.offer_stage.state === 10 ? <>
                                                                    <p className={styles.stageFeedbackLabelTopMargin}>Offer Send Details</p>
                                                                    <Row className={styles.adjustRowMarginsContentWithoutBorder}>
                                                                        <Col className='mb-3'>
                                                                            <Row>
                                                                                <Col md={2}>
                                                                                    <p className={styles.userDetailsTopicLabels}>Sent by</p>
                                                                                </Col>
                                                                                <Col className='ms-5'>
                                                                                    <p className={styles.userDetailsData}>
                                                                                        {hiringFlow.offer_stage.offer_sending_details.offer_sent_by ?
                                                                                            <span>{hiringFlow.offer_stage.offer_sending_details.offer_sent_by.first_name} {hiringFlow.offer_stage.offer_sending_details.offer_sent_by.last_name} ({hiringFlow.offer_stage.offer_sending_details.offer_sent_by.email})</span>
                                                                                            : <span> N/A </span>}
                                                                                    </p>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col md={2}>
                                                                                    <p className={styles.userDetailsTopicLabels}>Sent at</p>
                                                                                </Col>
                                                                                <Col className='ms-5'>
                                                                                    <p className={styles.userDetailsData}>
                                                                                        {hiringFlow.offer_stage.offer_sending_details.offer_sent_date ? <span>{moment(hiringFlow.offer_stage.offer_sending_details.offer_sent_date).format('MMMM Do YYYY, h:mm A')}(UTC)</span> : <span>N/A</span>}
                                                                                    </p>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col md={2}>
                                                                                    <p className={styles.userDetailsTopicLabels}>State</p>
                                                                                </Col>
                                                                                <Col className='ms-5'>
                                                                                    {hiringFlow.offer_stage.offer_sending_details.offer_sent_date ?
                                                                                        <p className={styles.reviewerStateSuccess}>
                                                                                            <span>Offer Sent</span>
                                                                                        </p> : <p className={styles.reviewerStateWarning}>
                                                                                            <span>Pending</span>
                                                                                        </p>}

                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row></> : null
                                                            }
                                                            {
                                                                (hiringFlow.offer_stage.offer_sending_details.offer_sent_by && !(hiringFlow.offer_stage.candidate_response)) &&
                                                                (
                                                                    <>
                                                                        <p className={styles.stageFeedbackLabelTopMargin}>Candidate Response</p>
                                                                        <Row className={styles.adjustRowMarginsContentWithoutBorder}>
                                                                            <Col>
                                                                                <Row>
                                                                                    <Col md={2}>
                                                                                        <p className={styles.userDetailsTopicLabels}>Response date</p>
                                                                                    </Col>
                                                                                    <Col className='ms-5'>
                                                                                        <p className={styles.userDetailsData}><span>N/A</span></p>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row>
                                                                                    <Col md={2}>
                                                                                        <p className={styles.userDetailsTopicLabels}>State</p>
                                                                                    </Col>
                                                                                    <Col className='ms-5'>
                                                                                        <p className={styles.reviewerStateWarning}>
                                                                                            <span>Pending</span>
                                                                                        </p>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        </Row>
                                                                    </>
                                                                )
                                                            }

                                                            {hiringFlow.offer_stage.candidate_response ? <>
                                                                <p className={styles.stageFeedbackLabelTopMargin}>Candidate Response</p>
                                                                <Row className={styles.adjustRowMarginsContentWithoutBorder}>
                                                                    <Col>
                                                                        <Row>
                                                                            <Col md={2}>
                                                                                <p className={styles.userDetailsTopicLabels}>Response date</p>
                                                                            </Col>
                                                                            <Col className='ms-5'>
                                                                                <p className={styles.userDetailsData}><span>{moment(hiringFlow.offer_stage.candidate_response.candidate_response_date).format('MMMM Do YYYY, h:mm A')}(UTC)</span></p>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col md={2}>
                                                                                <p className={styles.userDetailsTopicLabels}>State</p>
                                                                            </Col>
                                                                            <Col className='ms-5'>
                                                                                <p className={
                                                                                    hiringFlow.offer_stage.candidate_response.response_code === 30 ? styles.reviewerStateSuccess :
                                                                                        hiringFlow.offer_stage.candidate_response.response_code === -20 ? styles.reviewerStateWarning :
                                                                                            hiringFlow.offer_stage.candidate_response.response_code === 0 ? styles.reviewerStateWarning :
                                                                                                ''
                                                                                }>
                                                                                    {hiringFlow.offer_stage.candidate_response.response_code === 30 ? <span>Offer Accepted</span> :
                                                                                        hiringFlow.offer_stage.candidate_response.response_code === -20 ? <span>Candidate Declined</span> :
                                                                                            hiringFlow.offer_stage.candidate_response.response_code === 0 ? <span>Pending</span> : ''}
                                                                                </p>
                                                                            </Col>
                                                                        </Row>

                                                                    </Col>

                                                                </Row>
                                                            </>
                                                                : ''}

                                                        </Col>
                                                    </Row>

                                                    {hiringFlow.offer_stage.candidate_response && (hiringFlow.offer_stage.candidate_response.response_code == -20) &&
                                                        <Col>
                                                            <Row >
                                                                <Col>
                                                                    <div>
                                                                        <p className={styles.userDetailsTopicLabels}>Candidate Reject Reason</p>
                                                                        <span className={styles.rejectReson}><i className="fas fa-circle"></i>&nbsp;{hiringFlow.offer_stage.candidate_response.reason}</span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    }
                                                    {hiringFlow.offer_stage.offer_retraction_details.is_retracted &&
                                                        <Col>
                                                            <Row >
                                                                <Col>
                                                                    <div>
                                                                        <p className={styles.userDetailsTopicLabels}>Offer Retracted Reson</p>
                                                                        <span className={styles.rejectReson}><i className="fas fa-circle"></i>&nbsp;{hiringFlow.offer_stage.offer_retraction_details.retracted_reason}</span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    }

                                                </div>
                                            }

                                            {!hiringFlow.offer_stage && <Row className="ml-0 mr-0">
                                                <Col >
                                                    <p className={styles.noDataMessage}>Details Not Available</p>
                                                </Col>
                                            </Row>}
                                        </Card.Body>
                                    </Card>

                                    {/* Hired level */}
                                    <Card className={hiringFlow.hire_stage ? styles.customCardHiredStage : styles.customCardHiredStageDisabled}>
                                        <Card.Header className={hiringFlow.hire_stage ? styles.customCardHeaderHiredStage : styles.customCardHeaderHiredStageDisabled}>
                                            <Col>
                                                <Row>
                                                    <Col className={styles.centered}>
                                                        <span className="mt-1 mb-1">Hired Details</span>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Card.Header>
                                        <Card.Body className={styles.stageCardBody}>
                                            {hiringFlow.hire_stage && <Row className={styles.adjustRowMarginsContentWithoutBorder}>
                                                <Col >
                                                    <Row>
                                                        <Col lg={3}>
                                                            <p className={styles.userDetailsTopicLabels}>Hired Date </p>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.userDetailsData}>{hiringFlow.hire_stage && hiringFlow.hire_stage.hired_date ? hiringFlow.hire_stage.hired_date : 'N/A'}</p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col lg={2} className={styles.alingRight}>
                                                    <Alert variant="success" className={styles.badgeType}>Hired</Alert>
                                                </Col>

                                            </Row>}
                                            {!hiringFlow.hire_stage && <Row className="ml-0 mr-0">
                                                <Col >
                                                    <p className={styles.noDataMessage}>Details Not Available</p>
                                                </Col>
                                            </Row>}
                                        </Card.Body>
                                    </Card>
                                    {/* Onbord level */}
                                    <Card className={hiringFlow.hire_stage ? styles.customCardOnboardStage : styles.customCardOnboardStageDisabled}>
                                        <Card.Header className={hiringFlow.hire_stage ? styles.customCardHeaderOnboardStage : styles.customCardHeaderOnboardStageDisabled}>
                                            <Col>
                                                <Row>
                                                    <Col className={styles.centered}>
                                                        <span className="mt-1 mb-1">Onboard Stage Details</span>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Card.Header>
                                        <Card.Body className={styles.stageCardBody}>
                                            {hiringFlow.hire_stage && <Row className={styles.adjustRowMarginsContentWithoutBorder}>
                                                <Col >
                                                    <Row>
                                                        <Col lg={3}>
                                                            <p className={styles.userDetailsTopicLabels}>Onboarded by</p>
                                                        </Col>
                                                        <Col >
                                                            <p className={styles.userDetailsData}>{hiringFlow.hire_stage.passed_by ? <span>{hiringFlow.hire_stage.passed_by.first_name} {hiringFlow.hire_stage.passed_by.last_name} ({hiringFlow.hire_stage.passed_by.email})</span> : hiringFlow.hire_stage.rejected_by ? <span>{hiringFlow.hire_stage.rejected_by.first_name} {hiringFlow.hire_stage.rejected_by.last_name} ({hiringFlow.hire_stage.rejected_by.email})</span> : <span>N/A</span>}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg={3}>
                                                            <p className={styles.userDetailsTopicLabels}>Onboarded at </p>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.userDetailsData}>{hiringFlow.hire_stage.passed_date ? <span>{moment(hiringFlow.hire_stage.passed_date).format('MMMM Do YYYY, h:mm A')}(UTC)</span> : hiringFlow.hire_stage.rejected_date ? <span>{moment(hiringFlow.hire_stage.rejected_date).format('MMMM Do YYYY, h:mm A')}(UTC) </span> : <span>N/A</span>}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg={3}>
                                                            <p className={styles.userDetailsTopicLabels}>State </p>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.userDetailsData}><p className={styles.userDetailsData}>{hiringFlow.hire_stage.passed_by ? <span className={styles.reviewerStateSuccess}>Complete</span> : hiringFlow.hire_stage.rejected_by ? <span className={styles.reviewerStateSuccess}>Complete</span> : <span className={styles.reviewerStateWarning}>Pending</span>}</p></p>
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                <Col lg={2} className={styles.alingRight}>
                                                    {hiringFlow.hire_stage && candidateValues.current_state == 40 ?
                                                        <Alert variant="warning" className={styles.badgeTypeWarning}>Pending at Onboarding</Alert>
                                                        :
                                                        hiringFlow.hire_stage && hiringFlow.hire_stage.state === 30 ?
                                                            <Alert variant="success" className={styles.badgeType}>Pushed to HRIS</Alert>
                                                            :
                                                            hiringFlow.hire_stage && candidateValues.current_state == 40 ?
                                                                <Alert variant="danger" className={styles.badgeTypeFail}>Rejected at Onboarding</Alert>
                                                                : hiringFlow.hire_stage && candidateValues.current_state == 60 ?
                                                                    <Alert variant="success" className={styles.badgeType}>Onboarded</Alert>
                                                                    : hiringFlow.hire_stage && candidateValues.current_state == 65 ?
                                                                        <Alert variant="success" className={styles.badgeType}>Pushed to HRIS</Alert>
                                                                        : hiringFlow.hire_stage && candidateValues.current_state == -50 ?
                                                                            <Alert variant="danger" className={styles.badgeTypeFail}>Reject at Onboarding </Alert> :
                                                                            null
                                                    }
                                                </Col>

                                            </Row>}
                                            {hiringFlow.hire_stage && hiringFlow.hire_stage.state === -10 &&
                                                <Row>
                                                    <Col>
                                                        {hiringFlow.hire_stage && hiringFlow.hire_stage.state === -10 ?
                                                            <div>
                                                                <p className={styles.userDetailsTopicLabels}>Rejected at Onboarding Reason</p>
                                                                <span className={styles.rejectReson}><i className="fas fa-circle"></i>&nbsp;{hiringFlow.hire_stage.rejected_at_onboarding_reason}</span>
                                                            </div> : null
                                                        }
                                                    </Col>
                                                </Row>
                                            }
                                            {!hiringFlow.hire_stage && <Row className="ml-0 mr-0">
                                                <Col >
                                                    <p className={styles.noDataMessage}>Details Not Available</p>
                                                </Col>
                                            </Row>}
                                        </Card.Body>
                                    </Card>
                                </div>}
                            </Col>
                            <Col md={5} lg={4} xl={3}>
                                <Card className={styles.reviewSubmissionCard}>
                                    <Card.Header className={styles.reviewSubmissionCardHeader}>
                                        <div className={styles.reviewSubmissionCardheaderDetails}>
                                            <p className={styles.reviewSubmissionCardHeaderTopic}>Overall Feedback</p>
                                        </div>
                                    </Card.Header>
                                    <Card.Body>
                                        <div>
                                            <span className={styles.overallScoreLabel}>OVERALL SCORE</span>
                                            <div className={styles.scoreBar}>
                                                <div className={styles.overallScoreBar}>
                                                    <CircularProgressbar value={!candidateValues.overall_score ? 0 : candidateValues.overall_score} text={`${!candidateValues.overall_score ? 'N/A' : candidateValues.overall_score + '%'}`}
                                                        styles={{
                                                            text: {
                                                                fontSize: 'var(--app-xx-extra-large-font-size)',
                                                                fontFamily: 'var(--app-primary-font-style)',
                                                                fontWeight: 'var(--app-bold-font-weight)',
                                                                fill: '#2DA6C0'
                                                            },
                                                            path: {
                                                                // Path color
                                                                stroke: `#2DA6C0`,
                                                            },
                                                            trail: {
                                                                // Trail color
                                                                stroke: '#F2F2F2',
                                                            },

                                                        }}
                                                    />

                                                </div>


                                            </div>
                                            {candidateValues.review_criteria.length ?
                                                <div>
                                                    <span className={styles.overallScoreLabel}>Review Criteria</span>
                                                    <div className={styles.criteriaBoxOuterWrap}>
                                                        {candidateValues.review_criteria.map((item, i) => (
                                                            <Card className={styles.criteriaBox} key={i}>
                                                                <Card.Body className={styles.criteriaBoxBody}>
                                                                    <span className={styles.criteriaInnerBox}>
                                                                        <span className={styles.criteriaValue}>{item.label}</span>
                                                                        <span className={styles.criteriaStars}><StarRating className="mr-4" disabled={true} id={i} rate={item.rate} /></span>
                                                                    </span>
                                                                </Card.Body>
                                                            </Card>

                                                        ))}
                                                    </div>
                                                </div>
                                                : ''
                                            }


                                        </div>

                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        {candidateValues.current_state !== -100 && isUserRoleAdmin && (candidateValues.current_state === -10 || candidateValues.current_state === -20 || candidateValues.current_state === -30 || candidateValues.current_state === -40 || candidateValues.current_state === -50 || candidateValues.current_state === -60) &&
                            <div>
                                <div className={styles.dangerZoneTitleDiv}>
                                    <p className={styles.dangerZoneTitleText}>Danger zone</p>
                                </div>
                                <Row className={styles.dangerZoneBottomItem}>
                                    <Col sm={1} className={styles.deleteCandidateIcon}>
                                        <div className={styles.dangerZoneBottomItemSvg}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.3163 19.4384C5.92462 18.0052 7.34492 17 9 17H15C16.6551 17 18.0754 18.0052 18.6837 19.4384M16 9.5C16 11.7091 14.2091 13.5 12 13.5C9.79086 13.5 8 11.7091 8 9.5C8 7.29086 9.79086 5.5 12 5.5C14.2091 5.5 16 7.29086 16 9.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </Col>
                                    <Col sm={6}>
                                        <p className={styles.dangerZoneItemTitleText}>Delete Candidate</p>
                                        <p className={styles.dangerZoneItemSubTitleText}>Deleting the candidate's personal data First name, Last name, Mobile number, Email, Profile image, CV and Cover letter.
                                        This action is permanent and cannot be undone.</p>
                                    </Col>
                                    <Col sm={3}>
                                        <CustomButton
                                            buttonType="button"
                                            label="Delete Candidate"
                                            type="dangerBtn"
                                            handleClick={() => deleteCandidateDetails()}
                                            disabled={deleteCandidateProfileDisable ? true : false}
                                            backicon={deleteCandidateProfileDisable && <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        }
                    </Col>
                </div>)
            }
        </div >
    )
}

export default ViewSingleCandidate;